import React from 'react';
import { CheckCircle, AlertCircle, AlertTriangle } from 'lucide-react';
import styles from './ConnectionHealthBadge.module.css';

export default function ConnectionHealthBadge({ connection }) {
  const { health, token_status, has_write_permission } = connection;

  if (health === 'error') {
    return (
      <div className={styles.healthBadgeWrap}>
        <span className={`${styles.healthBadge} ${styles.healthBadgeError}`}>
          <AlertCircle size={16} />
          Action Required
        </span>
        <span className={styles.healthBadgeErrorMsg}>{token_status?.message || 'Reconnect required'}</span>
      </div>
    );
  }

  if (health === 'warning') {
    const message = has_write_permission === false
      ? 'Reconnect to enable event creation'
      : token_status?.message || 'Attention needed';
    const label = has_write_permission === false ? 'Limited Access' : 'Attention Needed';

    return (
      <div className={styles.healthBadgeWrap}>
        <span className={`${styles.healthBadge} ${styles.healthBadgeWarning}`}>
          <AlertTriangle size={16} />
          {label}
        </span>
        <span className={styles.healthBadgeWarningMsg}>{message}</span>
      </div>
    );
  }

  return (
    <span className={`${styles.healthBadge} ${styles.healthBadgeOk}`}>
      <CheckCircle size={16} />
      Connected
    </span>
  );
}
